module.exports = __webpack_public_path__ + "static/media/allie20.cb6b50e9.jpg";